<template>
    <form action="">
        <app-text-input
            label="Nombre"
            v-model="position.name"
            :has-error="$v.position.name.$error"
            error-message="Debe escribir el nombre del cargo"
            :required="true"
        />
        <app-select-input
            label="Superior"
            v-model="position.parentId"
            :options="positions"
        />
    </form>
</template>
<script>
import TextInput from "../../../UI/Controls/Forms/FormTextInput.vue";
import SelectInput from "../../../UI/Controls/Forms/FormSelectInput.vue";
import positionsRepository from "../../../../repositories/positions.repository";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapMutations } from "vuex";
import * as commitTypes from "../../../../store/commitTypes";

export default {
    components: {
        appTextInput: TextInput,
        appSelectInput: SelectInput
    },
    props: {
        selectedPosition: {
            type: Object,
            default: null
        },
        onSave: {
            type: Function,
            default: () => false
        },
        id: {
            type: String,
            default: () => `position-form-${parseInt(Math.random() * 10000000)}`
        }
    },
    data() {
        return {
            position: {
                id: "",
                name: "",
                parentId: ""
            }
        };
    },
    watch: {
        selectedPosition(val) {
            this.position = {
                id: val.id,
                name: val.name,
                parentId: val.parent_id
            };
        }
    },
    validations: {
        position: {
            name: { required }
        }
    },
    computed: {
        ...mapGetters(["positions"])
    },
    methods: {
        clear() {
            Object.keys(this.position).map(key => (this.position[key] = ""));
        },
        savePosition() {
            const pr = { ...positionsRepository };

            pr.savePosition(this.position)
                .then(data => {
                    if (data.status) {
                        this.clear();
                        toastr.success(
                            "Información guardada satisfactoriamente"
                        );
                        this.updatePositions(data.position);
                        this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al guardar el cargo");
                });
        },
        updatePositions(position) {
            const positions = this.positions.slice(0);
            const index = positions.findIndex(item => item.id === position.id);
            // Si el index es diferente de -1 se actualizó
            if (-1 !== index) {
                positions.splice(index, 1, position);
            } else {
                positions.push(position);
            }

            this.$store.commit(commitTypes.SET_POSITIONS, positions);
        }
    },
    created() {
        this.load("positions");
        this.$bus.$on("position-form.save", this.savePosition);
        this.$bus.$on(`${this.id}.clear`, this.clear);
    }
};
</script>
